"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetricVolumeType = void 0;
var MetricVolumeType;
(function (MetricVolumeType) {
    MetricVolumeType["OwnVolume"] = "own_volume";
    MetricVolumeType["Shared"] = "shared";
    MetricVolumeType["SharedPublic"] = "shared_public";
})(MetricVolumeType || (exports.MetricVolumeType = MetricVolumeType = {}));
//# sourceMappingURL=telemetry.js.map